import { createSlice } from "@reduxjs/toolkit";

const fileVersionsSlice = createSlice({
  name: "fileVersions",
  initialState: {},
  reducers: {
    setFileVersionData: (state, action) => {
      const { fileId, data } = action.payload;
      state[fileId] = data;
    },
    mergeFileVersionData: (state, action) => {
      const val = action.payload;
      if (!Array.isArray(state[val.fileId])) {
        state[val.fileId] = [];
      } else {
        state[val.fileId] = [...state[val.fileId]];
      }
      state[val.fileId].push(val);
    },
    setFileVersionStatus: (state) => state,
  },
});

const filesDataSlice = createSlice({
  name: "filesData",
  initialState: {},
  reducers: {
    setFilesData: (state, action) => ({ ...state, ...action.payload }),
    resetFilesData: (state) => state,
    modifyFileUnitsData: (state, action) => {
      const { fileVersionId, unitsNew } = action.payload;
      const fileData = state[fileVersionId];
      if (!fileData) return state;
      const updatedUnits = { ...fileData.Units, ...unitsNew };
      return {
        ...state,
        [fileVersionId]: { ...fileData, Units: updatedUnits },
      };
    },
  },
});

const fileDependenciesSlice = createSlice({
  name: "fileDependencies",
  initialState: {},
  reducers: {
    setFileDependencies: (state, action) => {
      const { fileVersionId, data } = action.payload;
      state[fileVersionId] = [...data];
    },
  },
});

const filesSharedUnderResourcesSlice = createSlice({
  name: "filesSharedUnderResources",
  initialState: {},
  reducers: {
    setResourcesUnderWhichFilesShared: (_state, action) => ({
      [action.payload.fileId]: action.payload.data,
    }),
  },
});

const currentFileVersionIdSlice = createSlice({
  name: "currentFileVersionId",
  initialState: "",
  reducers: {
    setFileVersionId: (_state, action) => action.payload,
  },
});

export const { setFileVersionData, mergeFileVersionData, setFileVersionStatus } = fileVersionsSlice.actions;

export const { setFilesData: setFilesDataAction, resetFilesData, modifyFileUnitsData } = filesDataSlice.actions;

export const { setFileDependencies: setFileDependenciesAction } = fileDependenciesSlice.actions;

export const { setResourcesUnderWhichFilesShared: setResourcesUnderWhichFilesSharedAction } =
  filesSharedUnderResourcesSlice.actions;

export const { setFileVersionId: setFileVersionIdAction } = currentFileVersionIdSlice.actions;

export const fileVersions = fileVersionsSlice.reducer;
export const setFilesData = filesDataSlice.reducer;
export const setFileDependencies = fileDependenciesSlice.reducer;
export const filesSharedUnderResources = filesSharedUnderResourcesSlice.reducer;
export const currentFileVersionId = currentFileVersionIdSlice.reducer;
